import { Grid } from '@material-ui/core'
import { useIntl } from 'react-intl'
import SingleProductEntry from './SingleProductEntry'
import { useRouter } from 'next/router'
import {
  ActiveLinkType,
  TabsEnum,
  useProductFromQueryParam,
} from '../ProductsConfiguration'
import CommonTabs, { CommonTab } from '@src/components/Common/CommonTabs'
import MultipleProductEntry from './MultipleProductEntry'
import { BiTubeProduct } from '../../BiTube/enum'

const Step1 = () => {
  const intl = useIntl()
  const { query, replace, pathname } = useRouter()
  const product = useProductFromQueryParam()
  const onTabChange = (tab: string) => {
    replace(
      {
        pathname: pathname,
        query: {
          ...query,
          activeLink: tab,
        },
      },
      undefined,
      { shallow: true }
    )
  }

  const tabs: CommonTab[] = [
    {
      label: intl.formatMessage({
        id: 'SINGLE_PRODUCT_ENTRY',
        defaultMessage: 'Single Product Entry',
      }),
      component: <SingleProductEntry />,
      id: 'single-product-entry',
      selectCallback: () => onTabChange(TabsEnum.SequenceEntry),
    },
    {
      label: intl.formatMessage({
        id: 'MULIPLE_PRODUCT_ENTRY',
        defaultMessage: 'Multiple Product Entry',
      }),
      component: <MultipleProductEntry />,
      id: 'multiple-product-entry',
      selectCallback: () => onTabChange(TabsEnum.MultipleEntry),
    },
  ]
  const tab =
    query.activeLink === ActiveLinkType.MultipleEntry
      ? 1
      : query.activeLink === ActiveLinkType.MultipleEntry
        ? 0
        : undefined

  const getStep1Component = () => {
    if (product === BiTubeProduct.LightCycler) {
      return <SingleProductEntry />
    }
    return <CommonTabs tabs={tabs} hideDivider activeTabIndex={tab} />
  }
  return (
    <Grid container spacing={6}>
      <Grid item xs={12}>
        {getStep1Component()}
      </Grid>
    </Grid>
  )
}

export default Step1
